/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PublicSchedulingActionsAliases {
  LAYOUT_PUBLIC_SCHEDULING_ACTIONS = 'layout-public-scheduling-actions',
  LOADER = 'loader',
  PANEL_LOADING = 'panel-loading',
}
export { PublicSchedulingActionsAliases };
